import React from 'react';
import getConfig from 'next/config';
import classNames from 'classnames';
import styles from './CartaxBanner.module.scss';
import { GTM_CLASS } from '../../../lib/constant';

const { CORE_URL } = getConfig().publicRuntimeConfig;

const CartaxBanner = () => {
  return (
    <div className={styles.cartaxBanner}>
      <div className={styles.cartaxBanner__title}>Urus Surat Kendaraan? Dirumah saja!</div>
      <div className={styles.cartaxBanner__subtitle}>
        Ngga perlu repot lagi untuk ngurus surat-surat kendaraan! Bersama Lifepal, semua jadi mudah!
      </div>
      <div className={classNames(styles.cartaxBanner__ctaBtn, GTM_CLASS.REDIRECTION_CARTAX)}>
        <a href={`${CORE_URL}/pajak-mobil/`}>Lihat Sekarang</a>
      </div>
    </div>
  );
};

export default CartaxBanner;
